<template>
    <div class="gray-back" style="padding:.2rem 0 0rem 0 ; height: 100%">
        <van-form
                @submit="onSubmit"
                @failed="onFailed"
        >
            <van-cell-group>
                <van-cell
                        :value="formData.activity.title"
                />
                <van-field
                        v-model="formData.content"
                        rows="2"
                        autosize
                        type="textarea"
                        maxlength="500"
                        placeholder="请说点什么..."
                        show-word-limit
                />

                <div class="row"  >
                    <PicUploader :fileList="formData.pics" :limit="9"
                                 :name="'pics'"></PicUploader>
                </div>
                <div class="operate-desc-left"   v-if="false">已上传{{formData.pics.length}}张最多上传9张照片</div>


            </van-cell-group>

            <div class="savebtn" v-if="canSubmit">
                <van-button
                        color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                        style="width: 3rem"
                        size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">提交</van-button>
            </div>
        </van-form>

        <LoginDialog :show="loginShow" @loginSuccess="loginSuccess" @loginCancel="loginCancel" />
    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }

    .memberResultWrap{
        background: #F3F3F3;
        margin: 0.2rem;
        border-radius: 8px;
        padding: 0.2rem;
    }
    .memberResultWrap .memberLi{
        font-size: 14px;
        color: #666;
        height: 36px;
        line-height: 36px;
    }
    .memberResultWrap .memberLi .van-tag{
        width: auto !important;
    }

    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';
    // import VideoUploader from '@/components/picker/VideoUploader.vue';

    import {Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon,Dialog, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';
    import CaipanPicker from '@/components/picker/CaipanPicker.vue';
    import JiaolianPicker from '@/components/picker/JiaolianPicker.vue';
    import LoginDialog from '@/components/LoginDialog.vue';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Dialog).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button);
    export default {
        name: 'ActivityContentForm',
        components: {
            [Field.name]: Field,
            PicUploader,
            // VideoUploader,
            CaipanPicker,
            JiaolianPicker,
            LoginDialog
        },
        data: function () {
            return {
                validator,
                loginShow:false,
                canSubmit:false,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                formData: {
                    id:0,
                    content:'',
                    activity:{
                    },
                    pics: [{name:"选择商户.png",
                        save_name:"h5/2020-05-11/1589187988243621.png",
                        uid:"vc-upload-1589187988243621",
                        url:"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-05-11/1589187988243621.png"
                    }],
                    video: [
                    ],
                },
                back:false
            }
        },
        filters: {},
        mounted() {
            let that = this;
            that.formData.activity_id = this.$route.query.activity_id;
            document.title = '发布动态';
            that.back = this.$route.query.back;
            that.fetch();

        },
        watch: {
            formData() {
            }
        },
        destroyed() {
        },
        methods: {
            fetch(){
                let that = this;
                that.$api.get('/api/activity/activityContentForm', {
                    activity_id : that.formData.activity_id,
                }, (res) => {
                    that.formData = Object.assign(that.formData, res.data);
                    that.canSubmit = true;

                },(res) =>{
                    console.log('没有登录');
                    if (res.code == 401 || res.code==402) {
                        if (window.isApp()) {
                            rbLink(
                                    {
                                        name: "login",
                                        query: {}
                                    },
                                    "replace"
                            );
                            return false;
                        }
                        that.loginShow = true
                    }else {
                        Toast(res.msg)
                    }
                })
            },
            onQuestion(){
                console.log('onQuestion')
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;
                for (let field in that.formData) {
                }
                that.saveLoading = true;
                that.$api.post('/api/activity/topicAdd', that.formData, (res) => {
                    that.saveLoading = false;
                    if(that.back>0){
                        rbLink({
                            'name':'',
                            'query':{ 
                            }
                        },'back')
                    }else{
                        rbLink({
                            'name':'ActivityActivity',
                            'query':{
                                id:that.formData.activity_id
                            }
                        })
                    }
                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onVideoInputClick(){
                let that =this;
                console.log({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.baoming.mingcheng,
                        'subject_name':this.formData.subject_name,
                    }
                });

                appEvent({
                    name:'onVideoInputClick',
                    query:{
                        'mingcheng':this.formData.baoming.mingcheng,
                        'subject_name':this.formData.subject_name,
                    }
                });
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },

            loginSuccess(res){
                console.log('-------登录成功--------',res);
                this.loginShow = false;
                this.fetch();
            },

            loginCancel(){
                console.log('-------取消登录--------');
                // this.loginShow = false;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// activityContentForm.vue?cf2f1a48